import type {
  FileModelType,
  ID,
  Maybe,
  Meta,
  MetaSeo,
  ModelType,
  SimpleDate,
} from '@/types'
import type { MakeMaybe, MakeRequired } from '@/types/utilities'

export interface PostListItem extends ModelType {
  name: Maybe<string>
  date: Maybe<SimpleDate>
  tag: Maybe<string>
  url: Maybe<string>

  teaser: Maybe<string>

  postings: PostElement[]

  seo: MetaSeo
}

export type Post = PostListItem

export type PostFormType = MakeMaybe<
  Pick<Post, 'id' | 'name' | 'active' | 'date' | 'tag' | 'url' | 'teaser'>,
  'id'
>

export type PostsMeta = MakeRequired<
  Meta<PostListItem, SelectedPostFilters>,
  'page' | 'total' | 'limit' | 'sort' | 'filters'
>

export interface SelectedPostFilters {
  isActive?: Maybe<boolean>
  hasIds?: ID[]
}
/**
 * PostElement / Postings
 * */
export interface FAQQuestion {
  question: string
  answer: string
}

export interface PostElement extends Omit<ModelType, 'sort'> {
  post_id: ID

  name: string
  type: PostElementType

  title?: string
  text?: string
  link?: string

  files?: FileModelType[]
  product_ids?: ID[]
  faq?: FAQQuestion[]
}

export type PostElementFormType = MakeRequired<
  MakeMaybe<
    Pick<
      PostElement,
      | 'id'
      | 'name'
      | 'post_id'
      | 'type'
      | 'title'
      | 'text'
      | 'link'
      | 'files'
      | 'product_ids'
      | 'faq'
      | 'active'
    >,
    'id' | 'name' | 'post_id' | 'text' | 'title' | 'link'
  >,
  'text' | 'link' | 'files' | 'product_ids' | 'faq'
>

export enum PostElementType {
  PhotoWide = 'photo_wide',
  Photo2 = 'photo_2',
  Photo3 = 'photo_3',
  PhotoGallery = 'photo_gallery',
  Video = 'video',
  Text = 'text',
  Quote = 'quote',
  ProductCarousel = 'product_carousel',
  Button = 'button',
  FAQ = 'faq',
}

export enum PostElementSection {
  Media = 'media',
  Text = 'text',
  Functional = 'functional',
}
